import EventHostHeader from './EventHostHeader'

export default EventHostHeader
